export default "__VITE_ASSET__DSI7Eroc__"